import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingRatings } from '../../components/NewbuildingRatings';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export function NewbuildingRatingsContainer(): React.JSX.Element {
  const { sections } = useSelector(getNewbuildingInfo);

  return <NewbuildingRatings sections={sections} />;
}
